export const PLAFOND_TYPE = Object.freeze({
    INITIATIVE: {
        key: 'initiative'
    },
    TOURISTIC: {
        key: 'touristic'
    }
});